// extracted by mini-css-extract-plugin
module.exports = {"PostSkeleton":"Post_PostSkeleton__2h0Fn"};